import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import HeroSection from '../../sections/HeroSection/HeroSection';
import WhyChooseUs from '../../sections/WhyChooseUs/WhyChooseUs';
import SupplierRewards from '../../sections/SupplierRewards/SupplierRewards';
import SellerJourney from '../../sections/SellerJourney/SellerJourney';
import LearningHub from '../../sections/LearningHub/LearningHub';
import DownloadApp from '../../sections/DownloadApp/DownloadApp';
import GrowBusiness from '../../sections/GrowBusiness/GrowBusiness';
import FooterSection from '../../sections/FooterSection/FooterSection';
import './Home.css';

export default function Home() {
  return (
    <div className="home-layout">
      {/* 1. Navbar */}
      <Navbar />

      {/* 2. Hero Section */}
      <HeroSection />

      {/* 3. Why Sellers Love Haatza */}
      <WhyChooseUs />

      {/* 4. Exclusive Supplier+ Rewards */}
      <SupplierRewards />

      {/* 5. Your Journey on Haatza */}
      <SellerJourney />

      {/* 6. Learning Hub */}
      <LearningHub />

      {/* 7. Grow Your Business with Haatza */}
      <GrowBusiness />

      {/* 8. Download Haatza App */}
      <DownloadApp />

      {/* 9. Footer */}
      <FooterSection />
    </div>
  );
}
